import { render } from "./ConstructorView.vue?vue&type=template&id=4e01927c"
import script from "./ConstructorView.vue?vue&type=script&lang=js"
export * from "./ConstructorView.vue?vue&type=script&lang=js"

import "./ConstructorView.vue?vue&type=style&index=0&id=4e01927c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__